import { EventSourcePolyfill } from 'event-source-polyfill';
import LocalStorageService from '../services/localstorage.service';
import { store } from '../store/';

const localStorageService = LocalStorageService.getService();

export default {
  install (Vue) {
    // use a new Vue instance as the interface for Vue components to receive/send SSE events
    // this way every component can listen to events or send new events using this.$sharedHub
    const sharedHub = new Vue()
    Vue.prototype.$sharedHub = sharedHub

    // Provide methods to connect/disconnect from the SSE endpoint
    let eventSource = null
    let manuallyClosed = false
    let reconnectTimeout = null

    sharedHub.startSse = () => {
      if (eventSource && eventSource.readyState !== EventSourcePolyfill.CLOSED) {
        return // Already connected
      }

      manuallyClosed = false

      function connect() {
        const token = localStorageService.getAuthToken();
        
        // Create SSE connection with Bearer token authentication in headers
        const url = `${Vue.prototype.$appConfig.hubBaseUrl}/sse/connect`;
        eventSource = new EventSourcePolyfill(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          heartbeatTimeout: 120000 // 2 minutes instead of default 45 seconds
        });

        // Handle connection open
        eventSource.addEventListener('open', () => {
          sharedHub.$emit('sseconnected')
          store.dispatch('maincontainer/setSseConnectionStatus', true);
          if (reconnectTimeout) {
            clearTimeout(reconnectTimeout)
            reconnectTimeout = null
          }
        });

        // Handle SSE events - map backend event names to lowercase for consistency
        eventSource.addEventListener('bannerChanged', (event) => {
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('bannerchanged', data)
          } catch (error) {
            // Error parsing bannerChanged data
          }
        });

        eventSource.addEventListener('documentReady', (event) => {
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('documentready', data)
          } catch (error) {
            // Error parsing documentReady data
          }
        });

        eventSource.addEventListener('refreshMessages', (event) => {
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('refreshmessages', data)
          } catch (error) {
            // Error parsing refreshMessages data
          }
        });

        eventSource.addEventListener('userTest', (event) => {
          try {
            const data = event.data ? JSON.parse(event.data) : null;
            sharedHub.$emit('usertest', data)
          } catch (error) {
            // Error parsing userTest data
          }
        });

        // Handle connection errors and reconnection
        // eslint-disable-next-line no-unused-vars
        eventSource.addEventListener('error', (error) => {
          // Notify about connection loss whenever error occurs (unless manually closed)
          if (!manuallyClosed) {
            store.dispatch('maincontainer/setSseConnectionStatus', false);
          }
          
          // Attempt reconnection only when connection is actually closed
          if (eventSource.readyState === EventSourcePolyfill.CLOSED && !manuallyClosed) {
            // Connection closed, attempt to reconnect after delay
            if (reconnectTimeout) {
              clearTimeout(reconnectTimeout)
            }
            reconnectTimeout = setTimeout(() => {
              connect()
            }, 10000) // Reconnect after 10 seconds
          }
        });
      }

      connect()
    }

    sharedHub.stopSse = () => {
      manuallyClosed = true
      
      store.dispatch('maincontainer/setSseConnectionStatus', false);
      
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout)
        reconnectTimeout = null
      }

      if (eventSource) {
        eventSource.close()
        eventSource = null
      }
    }
  }
}